import Loader from 'react-js-loader';

export const LoaderBubble = () => {
  return (
    <div className="pt-16">
      <Loader type="bubble-scale" bgColor={'#2497B2'} size={20} />
    </div>
  );
};
